/* tslint:disable */
/* eslint-disable */
/**
 * Vipps ePayment Internal API
 * The Vipps ePayment Internal api
 *
 * The version of the OpenAPI document: 0.9.0
 * Contact: teamecom@vipps.no
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const Currency = {
    Nok: 'NOK',
    Eur: 'EUR',
    Dkk: 'DKK'
} as const;
export type Currency = typeof Currency[keyof typeof Currency];


export function CurrencyFromJSON(json: any): Currency {
    return CurrencyFromJSONTyped(json, false);
}

export function CurrencyFromJSONTyped(json: any, ignoreDiscriminator: boolean): Currency {
    return json as Currency;
}

export function CurrencyToJSON(value?: Currency | null): any {
    return value as any;
}

